import Cut16 from '@carbon/icons-react/es/cut/16';
import OverflowMenuVertical16 from '@carbon/icons-react/es/overflow-menu--vertical/16';
import TrashCan16 from '@carbon/icons-react/es/trash-can/16';
import { Dropdown, Tooltip } from 'antd';
import moment from 'moment';
import React, { FC } from 'react';
import { Avatar } from 'components/atoms/avatar';
import { Button } from 'components/atoms/button';
import { Menu } from 'components/atoms/dropdown';
import { NameCell } from 'components/organisms/timesheets/common/cells/name-cell';
import { formatTime } from 'components/organisms/timesheets/common/format-time';

export const EventMoreDropdown: FC<{ onVisibleChange; onSplit; onRemove }> = ({
  onVisibleChange,
  onSplit,
  onRemove,
}) => {
  const split = 'Split';
  const remove = 'Remove';

  return (
    <Dropdown
      className="more-actions"
      onVisibleChange={onVisibleChange}
      overlay={
        <Menu onClick={() => onVisibleChange(false)}>
          <Menu.Item key="edit" icon={<Cut16 />} onClick={onSplit}>
            {split}
          </Menu.Item>

          <Menu.Item
            key="remove"
            danger
            icon={<TrashCan16 />}
            onClick={onRemove}
          >
            {remove}
          </Menu.Item>
        </Menu>
      }
      placement="bottomLeft"
      trigger={['click']}
    >
      <Tooltip title="More actions">
        <Button
          type="primary"
          icon={<OverflowMenuVertical16 />}
          size="small"
          data-cy="buttons.more-actions"
        />
      </Tooltip>
    </Dropdown>
  );
};

export const ProjectName: FC<{ name; description }> = ({
  name,
  description,
}) => {
  return (
    <NameCell
      primaryText={name}
      secondaryText={description}
      logo={<Avatar name={name} />}
    />
  );
};

export const UserName: FC<{ name }> = ({ name }) => {
  return <NameCell primaryText={name} logo={<Avatar name={name} />} />;
};
const getTooltipForProjectTimeline = (event) => {
  return `<span>Dates:</span><strong>${moment(event.startDate).format(
    'DD MMM',
  )} - ${moment(event.endDate).format('DD MMM')}</strong>`;
};
const getTooltipForProjectPhase = (event) => {
  return `<div><span>Phase name:</span><strong>${
    event.name
  }</strong></div><div><span>Dates:</span><strong>${moment(
    event.startDate,
  ).format('DD MMM')} - ${moment(event.endDate).format(
    'DD MMM',
  )}</strong></div>`;
};
const getTooltipForAllocation = (event) => {
  return `<div><span>Allocation:</span><strong>${formatTime(
    event.minutesPerDay,
  )}/d</strong></div><div><span>Dates:</span><strong>${moment(
    event.startDate,
  ).format('DD MMM')} - ${moment(event.endDate).format(
    'DD MMM',
  )}</strong></div>`;
};

export const getTooltipForEvent = (event) => {
  switch (event.type) {
    case 'project-phase':
      return getTooltipForProjectPhase(event);
    case 'allocation':
      return getTooltipForAllocation(event);
    case 'project':
      return getTooltipForProjectTimeline(event);
    default:
      return null;
  }
};
